import { Button } from '@neo/index'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@neo/primitives/dialog'
import { Tooltip } from '@neo/primitives/tooltip'
import { capitalize } from 'lodash'
import { TextQuoteIcon } from 'lucide-react'
import { CodeBlock } from 'v2/pages/contacts/data-capture-setup/components/code-block'

interface SchemaDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  fieldPath: string
  generateSchema: string
}

export const SchemaDialog = ({
  isOpen,
  onOpenChange,
  fieldPath,
  generateSchema,
}: SchemaDialogProps) => (
  <Dialog open={isOpen} onOpenChange={onOpenChange}>
    <DialogTrigger>
      <Tooltip content="Get Schema">
        <Button variant="outline" className="px-2">
          <TextQuoteIcon size={16} />
        </Button>
      </Tooltip>
    </DialogTrigger>
    <DialogContent className="max-w-[600px] max-h-[700px] overflow-hidden bg-card">
      <DialogHeader className="sticky top-0 border-b border-border bg-card z-[10] pr-6 mr-3 pb-3">
        <DialogTitle>
          {`${capitalize(fieldPath.split('.')[1].toLowerCase())}
            ${' '}
          Response Schema`}
        </DialogTitle>
      </DialogHeader>
      <div className="w-full overflow-x-auto overflow-y-auto max-h-[620px]">
        <CodeBlock code={generateSchema} language="json" clipboardCopyButtonPosition="topRight" />
      </div>
    </DialogContent>
  </Dialog>
)
